import { HistoryDto } from "@intelligems/ig-types";

export const getConfirmedIntegrationHistoryAction = (
  history: HistoryDto[]
): HistoryDto | undefined => {
  return history.find((event) => event.action === "confirmIntegration");
};
